import { FGTypography } from '@fg/design-system';
import Logo from 'assets/general/Logo_BMI_Geo_Risk_Signals_White.svg';

const NoQAPermissions = () => {
    return (
        <div className="preload-error">
            <div className="preload-error-logo">
                <img src={Logo} alt="" />
            </div>
            <FGTypography tag='p'>You do not have access to BMI Geo Risk Signals' QA platform. Please use <a href="https://app.geoquant.com" target="_blank" rel="noopener noreferrer">app.geoquant.com</a> instead.</FGTypography>
        </div>
    );
};

export default NoQAPermissions
